class SelectionMgr {
	constructor() {
		this._ids = [];
		this._items = [];

		this._setOf = null;

		this._clearFunction = null;

		this._menu = UI.div('selection-menu move', [
			this._count = UI.div('flex-0'),
			this._selectionBtns = UI.div('flex-1 text-center'),
			UI.div('flex-0', [this.clearBtn = UI.priIconBtn('times-circle', 18, {'click': this.clear.bind(this)})])
		]);
		document.body.appendChild(this._menu);
	}

	set clearFunction(fun) {
		this._clearFunction = fun;
	}

	get ids() {
		return this._ids.map(i => i);
	}

	get empty() {
		return this._items.length == 0;
	}

	set setOf(inst) {
		this._setOf = inst;
	}

	set items(items) {
		this._items = items;
	}

	addButton(btn) {
		this._selectionBtns.appendChild(btn);
	}

	recheck() {
		if (this._setOf == null) return;
		let i = 0;
		while(i < this._ids.length) {
			if (this._setOf.hasId(this._ids[i])){
				this._setOf.getById(this._ids[i]).checked = true;
				i++;
			}
			else {
				this._ids.splice(i, 1);
				this._items.splice(i, 1);
			}
		}
	}

	toggle(item) {
		if (!this.rem(item)) this.add(item);
		this.update();
	}
	
	add(item) {
		this._ids.push(item.id);
		this._items.push(item);
		item.checked = true;
	}
	
	rem(item) {
		let i = this._ids.indexOf(item.id);
		if (i === -1) return false;
		this._ids.splice(i,1);
		this._items.splice(i,1);
		item.checked = false;
		return true;
	}

	clear() {
		if (this._clearFunction != null) {
			this._clearFunction();
			return;
		}
		this._items.forEach(i => i.checked = false);
		this._ids = [];
		this._items = [];
		this.update();
	}

	update() {
		if (!this._menu) return;
		state(this._menu, this._items.length ? 'norm' : 'move');
		this._count.innerText = `${this._items.length} selected`;
	}

	hasId(id) {
		return this._ids.indexOf(id) !== -1;
	}
}